"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));

var _utils = require("@ckeditor/ckeditor5-ui/src/dropdown/utils");

var _collection = _interopRequireDefault(require("@ckeditor/ckeditor5-utils/src/collection"));

var _model = _interopRequireDefault(require("@ckeditor/ckeditor5-ui/src/model"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function getDropdownItemsDefinitions(options) {
  var itemDefinitions = new _collection["default"](); // Loop throught options, set key to commandParam to show in editor as variables
  // set title as dropdown labels

  options.forEach(function (item) {
    var definition = {
      type: 'button',
      model: new _model["default"]({
        commandParam: item.key,
        label: item.title,
        withText: true
      })
    }; // Add the item definition to the collection.

    itemDefinitions.add(definition);
  });
  return itemDefinitions;
}

var PlaceholderUI = /*#__PURE__*/function (_Plugin) {
  (0, _inherits2["default"])(PlaceholderUI, _Plugin);

  var _super = _createSuper(PlaceholderUI);

  function PlaceholderUI() {
    (0, _classCallCheck2["default"])(this, PlaceholderUI);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(PlaceholderUI, [{
    key: "init",
    value: function init() {
      var _this = this;

      var editor = this.editor;
      var t = editor.t;
      var types = editor.config.get('variablesPlaceholderPluginConfig.types'); // The "placeholder" dropdown must be registered among the UI components of the editor
      // to be displayed in the toolbar.

      editor.ui.componentFactory.add('placeholder', function (locale) {
        var dropdownView = (0, _utils.createDropdown)(locale); // Populate the list in the dropdown with items.

        (0, _utils.addListToDropdown)(dropdownView, getDropdownItemsDefinitions(types));
        dropdownView.buttonView.set({
          // The t() function helps localize the editor. All strings enclosed in t() can be
          // translated and change when the language of the editor changes.
          label: t('Insert Variable'),
          tooltip: true,
          withText: true
        }); // Disable the placeholder button when the command is disabled.

        var command = editor.commands.get('placeholder');
        dropdownView.bind('isEnabled').to(command); // Execute the command when the dropdown item is clicked (executed).

        _this.listenTo(dropdownView, 'execute', function (evt) {
          editor.execute('placeholder', {
            value: evt.source.commandParam
          });
          editor.editing.view.focus();
        });

        return dropdownView;
      });
    }
  }]);
  return PlaceholderUI;
}(_plugin["default"]);

exports["default"] = PlaceholderUI;
//# sourceMappingURL=placeholderui.js.map